import {React, useEffect} from 'external/react'

import {
  clsx,
  makeStyles,
  useTheme,
  Button,
  Box,
  Fade,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  ErrorIcon,
} from 'external/material'

const useStyles = makeStyles(notificationStyles)
const useTitleStyles = makeStyles(titleStyles)

export default function NotificationDialog (props) {
  const {open, onClose, onConfirm, context, notificationId: id, shouldConfirm = false} = props
  const {translate} = context
  const classes = useStyles()
  const titleClasses = useTitleStyles()
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))
  const [confirmed, setConfirmed] = React.useState(false)
  
  useEffect(() => {
    if (!open) {
      setConfirmed(false)
    }
  }, [open])

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      aria-labelledby="notification-dialog-title"
    >

      <Fade in={open} timeout={{exit: 0}}>
      <DialogTitle id="notification-dialog-title" classes={titleClasses}>
          <Box className={classes.icon}><ErrorIcon /></Box>
          <Box>{translate(`${id}-title`)}</Box>
      </DialogTitle>
      </Fade>

      <Fade in={open} timeout={{exit: 0}}>
      <DialogContent className={classes.content}>
        {shouldConfirm && (
          <FormControlLabel
            size="small"
            className={clsx(classes.notification, {shouldConfirm})}
            control={
              <Checkbox
                size="small"
                color="primary"
                checked={confirmed} 
                onChange={e => setConfirmed(e.target.checked)}
              />
            }
            label={translate(`${id}-message`)}
          />
        )}
        {!shouldConfirm && (
          <div className={clsx(classes.notification, {shouldConfirm})}>
            <Box>{translate(`${id}-message`)}</Box>
          </div>
        )}
      </DialogContent>
    </Fade>
      <Fade in={open} timeout={{exit: 0}}>
      <DialogActions className={classes.actions}>
        <Button
          variant="contained"
          color="background"
          className={clsx(classes.button, "cancel")}
          onClick={onClose}>
            {translate(`${id}-cancel`)}
        </Button>
        <Button
          variant="contained"
          color="error"
          className={clsx(classes.button, "confirm")}
          onClick={onConfirm}
          {...(!shouldConfirm || confirmed ? {} : {disabled: true})}
          >
            {translate(`${id}-confirm`)}
        </Button>
      </DialogActions>
</Fade>
    </Dialog>
  );
}

function titleStyles(theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
      fontSize: '14pt',
      fontWeight: 'bold',
      borderBottom: 'solid 1px #f3f3f3',
      background: '#fdfdfd'
    }
  }
}

function notificationStyles(theme) {
  return {
    content: {
      display: 'flex',
      paddingTop: '20px !important',
      flexGrow: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      minWidth: 280,
      maxWidth: 350,
    },
    icon: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      color: '#f4cc2c',
      fontSize: '15pt',
      marginTop: -1,
      marginRight: 10
    },
    notification: {
      color: '79797b',
      fontSize: '11.5pt',
      textAlign: 'center',
      '& .MuiFormControlLabel-label': {
        lineHeight: '1.1',
        fontSize: '11.5pt',
      },
      '&.shouldConfirm': {
        textAlign: 'justify'
      }
    },
    actions: {
      padding: 12,
      display: 'flex',
      justifyContent: 'center',
      borderTop: 'solid 1px #f3f3f3',
      background: '#fdfdfd'
    },
    filler: {
      flexGrow: 1
    },
    button: {
      textTransform: 'none',
      '&.cancel': {
        marginLeft: 0,
        marginRight: 0
      },
      '&.confirm': {
        marginLeft: 16,
      }
    }
  }
}

